import React from 'react';

const BenefitsContext = React.createContext({
    benefits: [],
    setBenefits: () => { }
})

export default BenefitsContext;